import styled from 'styled-components';
import { mediaBelow } from '../../assets/styles/helper';
import { uFlexColumn } from '../../assets/styles/utility';
import { variables } from '../../assets/styles/variables';
import { TWO_STEP_REGISTRATION_PAGE } from '../../constants/pages';

const { pathname } = window?.location;
const isTwoStepPage = pathname === TWO_STEP_REGISTRATION_PAGE;

// export const PageLayout = styled.div`
//   ${uFlexColumn};
//   flex: 1 1 auto;
//   padding-bottom: 7rem;
//   position: relative;

//   ${mediaBelow(variables.breakpoints.bpXl)} {
//     padding-bottom: 4rem;
//   }
// `;

// export const PageLayout = styled.div`
//   ${uFlexColumn};
//   flex: 1 1 auto;
//   max-height: 100%;
//   position: relative;
// `;

export const PageLayout = styled.div`
  ${uFlexColumn}
  flex: 1 1 auto;
  position: relative;

  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding-bottom: ${isTwoStepPage
      ? '0rem'
      : 'calc(4rem * var(--legacy-scale, 1))'};
  }
`;
